import { render, staticRenderFns } from "./assignmentretur.vue?vue&type=template&id=0f8e5df1"
import script from "./assignmentretur.vue?vue&type=script&lang=js"
export * from "./assignmentretur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports